import { render, staticRenderFns } from "./C1R_S3.vue?vue&type=template&id=0d9ede36&scoped=true"
import script from "./C1R_S3.vue?vue&type=script&lang=js"
export * from "./C1R_S3.vue?vue&type=script&lang=js"
import style0 from "./C1R_S3.vue?vue&type=style&index=0&id=0d9ede36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9ede36",
  null
  
)

export default component.exports